














import Proxyable from '@/mixins/proxyable';
import { IPaymentRequisition } from '@/models';
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default Proxyable.extend({
  name: 'RequisitionAPSpecialistPicker',

  props: {
    paymentRequisition: {
      type: Object as PropType<IPaymentRequisition>,
      required: true
    },
    externalErrorMessage: {
      type: String,
      default: () => ''
    }
  },

  data() {
    return {
      loading: false,
      errorMessage: ''
    };
  },

  computed: {
    ...mapGetters({
      apSpecialists: 'paymentRequisition/getPaymentRequisitionAPSpecialists'
    }),

    errorMessageList(): string[] {
      const errorList = [];
      if (this.externalErrorMessage) {
        errorList.push(this.externalErrorMessage);
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    this.errorMessage = '';
  },

  methods: {
    ...mapActions({
      fetchRequisitionAPSpecialists:
        'paymentRequisition/fetchRequisitionAPSpecialists'
    }),

    init() {
      this.loading = true;

      this.fetchRequisitionAPSpecialists(this.paymentRequisition.id)
        .catch(() => {
          this.errorMessage = 'Error getting AP Specialists';
        })
        .finally(() => (this.loading = false));
    }
  }
});
